module.exports = __webpack_public_path__ + "img/progress_021.60f2e1a9.png";